import { render, staticRenderFns } from "./MyPurchases.vue?vue&type=template&id=69201632&scoped=true"
import script from "./MyPurchases.vue?vue&type=script&lang=js"
export * from "./MyPurchases.vue?vue&type=script&lang=js"
import style0 from "./MyPurchases.vue?vue&type=style&index=0&id=69201632&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69201632",
  null
  
)

export default component.exports